<zef-dialog
  [open]="state.open"
  [options]="{ restoreFocus: false }"
  [autoFocus]="false"
  (closeTrigger)="onClose$.next()">
  <div class="__content  fx:relative">

    <zef-scrollbar maxHeight="80vh">

      <zui-form-section
        class="__form-section"
        separator="none">
        <span *zuiFormSectionTitle>
          @if (state.isEditMode) {
            Edit Integration Token
          } @else if (state.mode === tokenAddEditModes.ADD_USER) {
            Create User Access Token
          } @else {
            Create Integration Access Token
          }
        </span>

        <div *zuiFormSectionDesc>
          @if (state.isEditMode) {
          } @else if (state.mode === tokenAddEditModes.ADD_USER) {
            <span>User tokens will have the same exact rights as your account. Use for personal login to CLI and other personal use cases. If you need token for third party apps or CI/CD pipelines, see integration token.</span>
          } @else {
            <span>Customizable project-level permissions. Create tokens for your projects with roles ≤ yours. Ask managers for projects you can't access. For personal use (CLI), see personal tokens.</span>
          }
        </div>
      </zui-form-section>

      <div class="__integration-token-content">
        <zef-form
          #formRef
          class="fx:pt-1  fx:pb-1  fx:pl-1  fx:pr-1"
          [state]="state.formState"
          (submit)="onSubmit$.next()">

              <div class="__name-grid-item">
                <zef-form-field>
                  <mat-form-field
                    color="accent"
                    class="__name-form-field">

                    <mat-label>Token Name</mat-label>

                    <input
                      matInput
                      type="text"
                      [placeholder]="'Describe your token - will be used as identifier in the list'"
                      [ngrxFormControlState]="state.formState?.controls.name"
                      [ngrxEnableFocusTracking]="true"
                      class="__name-input"
                    />

                  </mat-form-field>
                </zef-form-field>
              </div>

              @if (state.showIntegrationFields && state.formState?.controls.roleCode) {

                <div class="__role-selector-grid-item  fx:pt-1">
                  <zui-token-primary-role-selector
                    [roleCodeControl]="state.formState.controls.roleCode"
                    [canCreateProjectsControl]="state.formState.controls.canCreateProjects"
                    [availableRoles]="state.availableTokenRoles || []"
                    [hideCreateProjectsToggle]="state.hideCreateProjectsToggle"
                  />
                </div>

                <div class="__project-access-grid-item">
                  <zef-form-field>

                    @if (state.availableTokenRoles?.length > 1) {
                      <zef-form-label class="fx:pl-0-5">Per Project Access Customization</zef-form-label>
                    }

                    <zui-project-access-override
                      [ngrxFormControlState]="state.formState?.controls.projects"
                      [availableProjects]="state.availableProjects || []"
                      [currentUserRole]="state.currentUser?.roleCode"
                      [currentUser]="state.currentUser"
                      [tokenPrimaryRole]="state.formState?.controls.roleCode?.value"
                      [changesMap]="state.projectChangesMap || emptyMap"
                      [addButtonText]="state.availableTokenRoles?.length === 1 && !state.formState?.controls.projects?.value?.value?.length ? 'Setup access to projects' : 'Set custom accesses'"
                    />

                  </zef-form-field>
                </div>

              }

            </zef-form>
          </div>

          @if (state.isEditMode) {
            <div class="__delegations">

              <zui-separator
                [orientation]="'horizontal'"
                [size]="'small'"
                [spacing]="'small'" />

              <zui-form-section class="__form-section" separator="none">
                <span *zuiFormSectionTitle>Delegations</span>
                <div *zuiFormSectionDesc>
                  <span>Each delegation lets this token create one new integration token with a fixed, pre-approved set of permissions, owned by the user who created the delegation - not by this token. It's what ZCP uses when preparing a production project. A delegation never changes what this token itself can access.</span>
                </div>
              </zui-form-section>

              <div class="__delegations-body">

                @if (state.delegationsLoading && !state.tokenDelegations?.length) {

                  <div class="__delegations-loading">
                    <zui-three-dots />
                  </div>

                } @else if (state.delegationCreateOpen) {

                  <!-- CREATE DELEGATION -->
                  <zef-form
                    #delegationFormRef
                    #delegationCreateAnchor
                    [state]="state.delegationFormState"
                    (submit)="onSubmitDelegation$.next()">

                    @if (state.delegationFormState?.controls.roleCode) {
                      <zui-token-primary-role-selector
                        [roleCodeControl]="state.delegationFormState.controls.roleCode"
                        [canCreateProjectsControl]="state.delegationFormState.controls.canCreateProjects"
                        [availableRoles]="state.availableTokenRoles || []"
                        [hideCreateProjectsToggle]="state.hideCreateProjectsToggle" />

                      <div class="__project-access-grid-item  fx:pt-1">
                        <zef-form-field>
                          @if (state.availableTokenRoles?.length > 1) {
                            <zef-form-label class="fx:pl-0-5">Per Project Access Customization</zef-form-label>
                          }
                          <zui-project-access-override
                            [ngrxFormControlState]="state.delegationFormState?.controls.projects"
                            [availableProjects]="state.availableProjects || []"
                            [currentUserRole]="state.currentUser?.roleCode"
                            [currentUser]="state.currentUser"
                            [tokenPrimaryRole]="state.delegationFormState?.controls.roleCode?.value"
                            [changesMap]="emptyMap"
                            [addButtonText]="'Set custom accesses'" />
                        </zef-form-field>
                      </div>
                    }
                  </zef-form>

                  <div class="__delegation-create-actions">
                    <zef-progress-error full [key]="addDelegationKey">
                      <button
                        class="c-button--full  c-button--smaller"
                        color="accent"
                        mat-flat-button
                        type="button"
                        (click)="delegationFormRef?.triggerSubmit()">
                        Create delegation
                      </button>
                    </zef-progress-error>
                    <button
                      class="c-button--smaller"
                      mat-button
                      type="button"
                      (click)="onCancelCreateDelegation$.next()">
                      Cancel
                    </button>
                  </div>

                } @else {

                  <!-- LIST -->
                  @for (delegation of state.tokenDelegations; track delegation.id) {
                    <div class="__delegation-row">

                      <div class="__delegation-head">
                        <button
                          class="__delegation-toggle"
                          type="button"
                          (click)="expandedDelegationId.set(expandedDelegationId() === delegation.id ? undefined : delegation.id)">
                          <mat-icon class="__delegation-caret">{{ expandedDelegationId() === delegation.id ? 'expand_less' : 'expand_more' }}</mat-icon>
                          <span class="__delegation-role">{{ delegationRoleLabels[delegation.tokenPermissions.roleCode] || delegation.tokenPermissions.roleCode }}</span>
                          <span class="__delegation-summary-text">
                            {{ delegation.tokenPermissions.projectPermissions?.length || 0 }} project {{ (delegation.tokenPermissions.projectPermissions?.length || 0) === 1 ? 'permission' : 'permissions' }}@if (delegation.tokenPermissions.canCreateProjects) {<span> · can create projects</span>}
                          </span>
                          <span class="__delegation-date">{{ delegation.created | date: 'dd. MM. yyyy' }}</span>
                        </button>

                        <zui-progress-spinner
                          [isLoading]="!!state.deleteDelegationProgressesMap?.[delegation.id]"
                          hideContent
                          class="__delegation-delete">
                          <button
                            mat-icon-button
                            color="warn"
                            type="button"
                            class="c-button--smaller"
                            (click)="deleteDelegationBtnRef.open()"
                            [zuiDynamicPopAnchor]="confirmDelegationPopRef.popRef()"
                            #deleteDelegationBtnRef="dynamicPopAnchor">
                            <mat-icon class="__delegation-delete-icon">delete_outline</mat-icon>
                          </button>
                        </zui-progress-spinner>

                        <zui-confirm-pop
                          #confirmDelegationPopRef
                          [heading]="'Delete this delegation?'"
                          [confirmButtonText]="'general.confirm' | transloco"
                          [verticalAlign]="'below'"
                          [closeButtonText]="'general.close' | transloco"
                          (confirm)="onDeleteDelegation$.next(delegation.id)">
                        </zui-confirm-pop>
                      </div>

                      @if (expandedDelegationId() === delegation.id) {
                        <div class="__delegation-detail">
                          @if (delegation.tokenPermissions.canCreateProjects || delegation.tokenPermissions.canViewFinances || delegation.tokenPermissions.canEditFinances) {
                            <div class="__delegation-flags">
                              @if (delegation.tokenPermissions.canCreateProjects) { <span class="__delegation-flag">Can create projects</span> }
                              @if (delegation.tokenPermissions.canViewFinances) { <span class="__delegation-flag">Can view finances</span> }
                              @if (delegation.tokenPermissions.canEditFinances) { <span class="__delegation-flag">Can edit finances</span> }
                            </div>
                          }
                          @if (delegation.tokenPermissions.projectPermissions?.length) {
                            <div class="__delegation-projects">
                              @for (pp of delegation.tokenPermissions.projectPermissions; track pp.projectId) {
                                <div class="__delegation-project">
                                  <span class="__delegation-project-name">{{ state.projectsNameMap?.get(pp.projectId) || pp.projectId }}</span>
                                  <span class="__delegation-project-role">{{ delegationRoleLabels[pp.roleCode] || pp.roleCode }}</span>
                                </div>
                              }
                            </div>
                          } @else {
                            <div class="__delegation-detail-empty">No per-project permissions.</div>
                          }
                        </div>
                      }
                    </div>
                  } @empty {
                    <div class="__delegations-empty">No delegations yet.</div>
                  }

                  <button
                    class="c-button--smaller  __delegation-create-button"
                    mat-stroked-button
                    color="accent"
                    type="button"
                    (click)="expandedDelegationId.set(undefined); onOpenCreateDelegation$.next()">
                    <mat-icon fontSet="material-icons-outlined">add</mat-icon>&nbsp;<span>Create delegation</span>
                  </button>

                }

              </div>
            </div>
          }

    </zef-scrollbar>

    <!-- Buttons Section -->
    <div class="__buttons">
      <div class="__buttons-grid">
        <div>
          <zef-progress-error
            full
            [key]="state.isEditMode ? updateIntegrationTokenKey : [addUserTokenKey, addIntegrationTokenKey]">
            <button
              class="__button __primary-button c-button--full"
              color="accent"
              mat-flat-button
              type="button"
              (click)="formRef?.triggerSubmit()">
                {{ state.isEditMode ? 'Update Token' : 'Create Token' }}
              </button>
          </zef-progress-error>
        </div>

        <div>
          <button
            (click)="onClose$.next()"
            class="c-button--full"
            type="button"
            mat-button>
            <span transloco="general.close"></span>
          </button>
        </div>
      </div>
    </div>

  </div>
</zef-dialog>
